<template>
  <div class="pgp-meta">
    <p class="pgp-remind">{{ encryptReminder }}</p>
    <a class="btn btn-primary" href="/.well-known/pgp-key.asc">{{ t('downloadPgp') }}</a>
    <p v-if="!hasPgpPublicKey" class="pgp-empty">{{ t('noPgp') }}</p>
    <p v-if="pgpKeyId || pgpFingerprint" class="pgp-ids">
      <span v-if="pgpKeyId">{{ t('pgpKeyId') }} {{ pgpKeyId }}</span>
      <span v-if="pgpKeyId && pgpFingerprint"> · </span>
      <span v-if="pgpFingerprint">{{ t('pgpFingerprint') }} {{ pgpFingerprint }}</span>
    </p>
  </div>
</template>
<script>
import { t } from '../i18n'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'pgp-meta',
  computed: {
    ...mapState(['locale']),
    ...mapGetters(['encryptReminder', 'hasPgpPublicKey', 'pgpKeyId', 'pgpFingerprint'])
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    }
  }
}
</script>
